<template>
    <div
        class="h-full top-20 w-full fixed bg-cover bg-center bg-no-repeat -z-[550]"
        id="header"
        :style="'background-image: url(' + $asset('/hkcm/images/auth.png', 'public') + ')'"
    ></div>
    <div class="h-[250px] items-center flex lg:block lg:h-[360px] lg:relative w-full">
        <div class="lg:absolute top-0 left-0 w-full h-full flex flex-col justify-center z-20">
            <div class="container mx-auto">
                <h2 v-if="headlineBlue" class="text-sm py-4 text-blue text-center font-normal" data-aos="fade-down" data-aos-duration="250">
                    {{ headlineBlue }}
                </h2>
                <h3 v-if="headline" class="text-6xl text-black text-center !font-bold" data-aos="zoom-in" data-aos-duration="250">
                    {{ headline }}
                </h3>
                <p v-if="subline" class="text-black text-center pt-8 lg:w-9/12 m-auto" data-aos="fade-up" data-aos-duration="250">
                    {{ subline }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['headlineBlue', 'headline', 'subline']
};
</script>
